import type { GroupEdgeSettingsId } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface SetDraggedGroupIdCommand {
  groupId: GroupEdgeSettingsId | null;
}

export const setDraggedGroupId: GraphCommandFactory<SetDraggedGroupIdCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      draft.layoutSettings.draggedGroupId = command.groupId;
    });
  };
